import { TermsOfService } from 'TermsOfService';

const TermsOfServicePage = (): JSX.Element => {
	return <TermsOfService />;
};

export default TermsOfServicePage;
